import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_URL, BASE_BONUS_URL } from '../apiConfig';

export const fetchBonusDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_BONUS_URL}/get-details`,
    payload,
  );
  return response.data;
};

export const fetchPCMRating = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_BONUS_URL}/get-pcmrating`,
    payload,
  );
  return response;
};
